var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.localValue.type === 'accept')?_c('div',{attrs:{"id":'localValue' + _vm.index}},[_c('div',{staticClass:"flex",style:('padding: ' + _vm.styles.padding.join('px ') + 'px;' + 
      'margin: ' + _vm.styles.margin.join('px ') + 'px;' + 
      'justify-content: ' + _vm.styles.text.textAlign + ';' +

      'font-family:' + (_vm.styles.text.fontFamily || '') + ';' + 
      'text-shadow:' + (_vm.styles.text.textShadow || '') + ';' + 
      'font-size:' + _vm.styles.text.fontSize + 'px;' + 
      'text-align:' + _vm.styles.text.textAlign + ';' + 
      'font-style:' + (_vm.styles.text.fontStyle || '') + ';' +
      'font-weight:' + (_vm.styles.text.fontWeight || '') + ';' +
      'letter-spacing:' + (_vm.styles.text.letterSpacing || '') + ';' +
      'line-height:' + (_vm.styles.text.lineHeight || '') + ';' +
      '-webkit-text-stroke-width:' + (_vm.styles.text.textStrokeWidth || '') + ';' +
      '-webkit-text-stroke-color:' + (_vm.styles.text.textStrokeColor || '') + ';' +
      'text-decoration-line:' + (_vm.styles.text.textDecorationLine || '') + ';' +
      'color:' + _vm.styles.text.color + ';' +
      _vm.styles.customStyles ?? '')},[_c('label',{staticClass:"container text-sm",staticStyle:{"display":"inline-block","width":"auto"}},[_vm._v(" "+_vm._s(_vm.localValue.placeholder)+" "),_c('input',{attrs:{"type":"checkbox"}}),_c('span',{staticClass:"checkmark",style:('--form-style-color:' + _vm.styles.iconColor + ';' +
        '--form-style-background:' + _vm.styles.backgroundColor)})])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }